import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    description: 'App wide Scan to View - Access Denied Modal - Title',
    defaultMessage: 'Access Denied',
    id: '49I2Vm',
  },
  message: {
    description: 'App wide Scan to View - Access Denied Modal - Message',
    defaultMessage: 'Order restricted due to user permission settings',
    id: 'G06npR',
  },
});
